// Any changes need to also be made to angular offer-email-templates-mustache.js file
//  located here: /web/app/assets/javascripts/common/templates/offer-email-templates.mustache.js
/* tslint:disable */
export const offerTemplates = [
  {
    label: 'First Offer',
    message: `Hi {{lead.first_name}},

We just finished analyzing your home's market value, and we're excited to make you an offer!

I'm {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Experience a hassle-free sale: Sell your home without showings, staging, and months of stress.
- Move when you’re ready: Choose your own close date for complete flexibility and control of your moving timeline.
- Close with certainty: No contingencies or fall-through risk so you can focus on your next home.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Seller estimate high, pivot to LWOD',
    message: `Hi {{lead.first_name}},

We just finished analyzing your home's market value.
Based upon the numbers that you initially provided, I have another selling option that might be a better solution for your selling goals, which I can go over in more detail on the phone if you'd like.

Here is the offer though for your interest:

$OFFER_LINK
<br>
<br>

If you were to go through the Sell Now option here are some benefits:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Option to rent the home back for a nominal daily rate to help with a smooth transition.

<br>
Talk to you soon.

Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Home Advisor, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>
`,
  },
  {
    label: 'During offer call',
    message: `Hi {{lead.first_name}},

Thanks for requesting an offer from Opendoor. Your offer is ready and I would like to go over it with you on the phone to be sure that all of your questions are answered.

Please view your offer now so that we can walk through it together:

$OFFER_LINK
<br>
<br>

With Opendoor you're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Please don’t hesitate to follow up to this email if you run into any additional questions after our call.

Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>
`,
  },
  {
    label: 'After Offer call',
    message: `Hi {{lead.first_name}},

It was nice chatting on the phone with you earlier today! Thanks again for requesting an offer from Opendoor.

As we discussed you can review your offer page here:

$OFFER_LINK
<br>
<br>

As a reminder, with Opendoor you're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Please don’t hesitate to follow up to this email if you run into any additional questions.

Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>
`,
  },
  {
    label: "Couldn't reach for offer call",
    message: `Hi {{lead.first_name}},

We analyzed your home's market value, and we're excited to make you an offer!

I'm {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works. I tried giving you a call to discuss your offer over the phone but I was unable to reach you.

Please take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

With Opendoor you're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Please don’t hesitate to follow up to this email if you run into any additional questions.

Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>
`,
  },
  {
    label: 'Basic AE template',
    message: `Hi {{lead.first_name}},

We analyzed your home's market value, and we're excited to make you an offer!

I'm {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works.

Please take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

With Opendoor you're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Please don’t hesitate to follow up to this email if you run into any additional questions.

Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Home Advisor, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>
`,
  },
  {
    label: 'High Fee Offer',
    message: `Hi {{lead.first_name}},

Thank you for requesting an offer from us.

We strive to make offers with service charges that range from 6-12%, which reflect our internal costs. Unfortunately in the case of your home, our projected holding costs fall above that range.

We know there are many ways you can choose to sell your home, and we completely understand if our offer isn’t right for you at this time. We would be happy to recommend an agent if that would be helpful.

If you would like to review and consider the offer we’ve prepared for you, take a look using the link below:

$OFFER_LINK
<br>
<br>

With any questions at all, please don’t hesitate to reach out.

Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>
`,
  },
  {
    label: 'Seller Estimate Higher',
    message: `Hi {{lead.first_name}},

I want to acknowledge that the estimate you put down for your home is higher than what we’ve landed on as our offer. We try our best to come up with a market value offer based on data, your inputs and photos we have, but we don’t always nail it. If you think we may have missed something or want to learn more about how we came up with the offer, we’re always happy to go over that with you.


I'm {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Seller Estimate & Postcard Estimate Higher',
    message: `Hi {{lead.first_name}},

I'm {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works.

I do want to acknowledge that it looks like the mailer valuation range and the estimate that you provided are both higher than what our formal valuation analysis is coming out to. Our postcard offers are an estimate of your home's value, not based on an in-depth analysis like we just did, and we are sometimes off. If you think we may have missed something or want to learn more about how we came up with the offer, I’d love to speak on the phone with you.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Mailer Range Higher Than Offer',
    message: `Hi {{lead.first_name}},

I want to acknowledge that it looks like the offer we’ve put together for you has come in just outside of the valuation range that we estimated on the mailer we sent you. Those ranges are an estimate of your home's value, and are not based on an in-depth analysis like we did to put together this offer for you. We are a growing company and still make mistakes, so I’m sorry if we wasted your time and created a disappointing experience. If you think we may have missed something or want to learn more about how we came up with the offer, I’d love to speak on the phone with you.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Leased Solar Panels',
    message: `Hi {{lead.first_name}},

We just finished analyzing your home's market value, and we're excited to make you an offer! We noticed you have leased solar panels, and we wanted to let you know that our offer would be contingent upon the removal of the panels or buyout of your lease.

I'm {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Tenant Occupied - Contingent',
    message: `Hi {{lead.first_name}},

We just finished analyzing your home's market value, and we're excited to make you an offer! We noticed that your home is tenant occupied. Please note that our offer is contingent upon the completion of their lease and assumes that the tenants will be completely moved out by the close of escrow.

I'm {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'DFW – SQFT Variance',
    message: `Hi {{lead.first_name}},

We just finished analyzing your home's market value, and we're excited to make you an offer!

I'm {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works.

We noticed a discrepancy between the square footage that you inputted and the tax records.  As I’m sure you can understand, we needed to use the number tax records provided for our analysis, but if you are able to present documentation showing a different square footage we will happily adjust our offer based on the new numbers.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
    `,
  },
  {
    label: 'Old Listing Photos',
    message: `Hi {{lead.first_name}},

We just finished analyzing your home's market value, and we're excited to make you an offer!

I'm {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works.

Your offer is based on the information you provided us and any photos we have available to us, which in your case was from the last listing. I saw that you put a significant amount into upgrading your home, so if you are interested in sending us photos so we can take a closer look at the current condition of your home, please feel free.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
    `,
  },
  {
    label: 'Photos Received – Same Offer',
    message: `Hi {{lead.first_name}},

Thanks for sending photos through so we could take a closer look at your home, you have a beautiful home. After viewing the photos and comparing them to our initial assumptions about your home from the questionnaire you completed, we believe our initial offer is still our best estimate of fair market value so this offer remains unchanged.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
    `,
  },
  {
    label: 'Photos Received – Higher Offer',
    message: `Hi {{lead.first_name}},

Thanks for sending photos through so we could take a closer look at your home. Upon viewing the photos we believe we came in too low with our initial offer and would love to offer you more based on what we learned from the photos you shared.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Photos Received – Lower Offer',
    message: `Hi {{lead.first_name}},

Thanks for sending photos through so we could take a closer look at your home. Upon viewing the photos we believe we came in too high with our initial offer and will need to lower our offer based on what we learned from photos you shared.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Second Offer – Same Offer',
    message: `Hi {{lead.first_name}},

Thanks for requesting a refreshed offer from Opendoor!  We took another look at your home and nearby comps and determined that market changes have been minimal so your offer has not changed.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Second Offer – Higher Offer (with Comp)',
    message: `Hi {{lead.first_name}},

Thanks for requesting a refreshed offer from Opendoor! We took another look at your home and nearby comps and determined that market changes support a higher offer for your home. This includes the recently sold comp at [Insert Comp Here] which sold for [Insert Sale Price Here].

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Second Offer – Higher Offer (Generic)',
    message: `Hi {{lead.first_name}},

Thanks for requesting a refreshed offer from Opendoor!  We took another look at your home and nearby comps and determined that market changes support a higher offer for your home.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Second Offer – Lower Offer (with Comp)',
    message: `Hi {{lead.first_name}},

Thanks for requesting a refreshed offer from Opendoor! We took another look at your home and nearby comps and determined that market changes have required us to lower your offer. This includes the recently sold comp at [Insert Comp Here] which sold for [Insert Sale Price Here].

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Second Offer – Lower Offer (Generic)',
    message: `Hi {{lead.first_name}},

Thanks for requesting a refreshed offer from Opendoor! I want to give you a heads up that after taking another look at the details of your home and reassessing, we have made some adjustments which required us to lower your offer.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

You're able to:

- Choose when you move.
- Skip intrusive and inconvenient home showings.
- Get full value without paying <a href='https://www.opendoor.com/blog/7-hidden-costs-of-selling'>the many hidden costs of a traditional sale</a>.

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
  {
    label: 'Low Offer Score – Same Offer',
    message: `Hi {{lead.first_name}},

Thanks for your patience while we took another look at our original offer on your home. After an in depth review with our property valuation professional we found the original price we offered was a fair price. The team is confident that our offer is the highest we can make at this time, as it is the amount we believe your home would sell for on the open market.

Here are the details of your offer if you’d like to reconsider:

$OFFER_LINK

We wish you the best in selling your home, and thank you for considering Opendoor.

Best,
{{offer.acq_cx_lead.name}}
`,
  },
  {
    label: 'Low Offer Score – Same Offer & High Fees',
    message: `Hi {{lead.first_name}},

Thanks for your patience while we took another look at our original offer on your home. After an in depth review with our property valuation professional we found the original price we offered was a fair price. The team is confident that our offer is the highest we can make at this time, as it is the amount we believe your home would sell for on the open market. As for the fees, I understand they can definitely feel a bit high compared to the traditional process. For those who feel the convenience and certainty is worth the fees -- our current customers -- it's a great experience, but I can understand if that's not the case for everyone.

Here are the details of your offer if you’d like to reconsider:

$OFFER_LINK

We wish you the best in selling your home, and thank you for considering Opendoor.

Best,
{{offer.acq_cx_lead.name}}
`,
  },
  {
    label: 'Low Offer Score – Revised Offer',
    message: `Hi {{lead.first_name}},

We’re pleased to report that we’ve found additional evidence that supports a higher offer on your home. Based on a second look at comps and adjustments, our original offer was lower than fair market value and we’d like to make you a new offer.

$OFFER_LINK

At Opendoor our mission is to put our customers first and we value your feedback. As a new company that’s growing quickly, sometimes we make mistakes and we aim to correct them with great service and transparency. Please let us know what you think. To accept this offer please click the “Set Up Contract” button on your offer page.

Thanks again for checking out Opendoor.

Best,
{{offer.acq_cx_lead.name}}
`,
  },
  {
    label: 'Discount Error',
    message: `Hi {{lead.first_name}},

We made a mistake with the offer we recently sent you. We discovered a system error where the market risk charge for your offer was higher than it should have been, which resulted an offer that was lower than it should have been. That error has been corrected and I would like to present you with an updated offer:

$OFFER_LINK
<br>
<br>

I apologize for the poor experience we created with our first offer and hope you’ll consider our updated offer.


After you've viewed the new offer, please reach out to let me know what you think, I’d love to hear from you!

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Experience Manager, Opendoor<br>
{{offer.acq_cx_lead.display_phone_number}}
`,
  },
  {
    label: 'Acquisition Offer',
    message: `Hi {{lead.first_name}},

We just finished analyzing your home's market value, and we're excited to make you an offer!

My name is {{offer.acq_cx_lead.full_name}}, and I'm here to answer any questions about your offer and how Opendoor works.

When you receive an offer from Opendoor AND you are also working with a homebuilder for your next home, here is what you can expect from us:

- You can extend your close date for up to <u>9 months</u> to match the day your new home will be ready.
- Move when you’re ready: Choose your own close date for complete flexibility and control of your moving timeline.
- You have the option to stay in your property for up to <u>2 extra days</u> past your close date to make your transition easy.
- Experience a hassle-free sale: Sell your home without showings, staging, and months of stress.

Take a look and let me know what you think:

$OFFER_LINK
<br>
<br>

<br>
Talk to you soon.


Best,<br>
{{offer.acq_cx_lead.name}}<br>
<br>
--<br>
{{offer.acq_cx_lead.full_name}}<br>
Home Advisor, Opendoor<br>
Direct: {{offer.acq_cx_lead.display_phone_number}}
1-800-491-7076
<br><br>

<i>"Opendoor’s offer came in right near our appraisal, but we never had to list the house or do showings. For the kind of value Opendoor gives you, it’s just a no-brainer."</i><br>
Adam Leon, Phoenix AZ
`,
  },
];
